var sBusSearchFilter = function() {

	this.init = function (){	
		
		$("input[type='checkbox'][name='className']").click(function() {
			applyDepartureFilter();
		});
		
		$("input[type='checkbox'][name='resultRetClass']").click(function() {
			applyReturnFilter();
		});
		
		$("input[type='checkbox'][name='boatType']").click(function() {
			applyDepartureFilter();
			applyReturnFilter();
		});
		
		
		if(SBus.sBusDepartureResultTable != null){
			
			var minPrice = $(SBus.sBusDepartureResultTable.first()).attr("data-minprice");
			var maxPrice = $(SBus.sBusDepartureResultTable.last()).attr("data-minprice");
			var minSliderValue = parseInt(minPrice / 10, 10) * 10;
			var maxSliderValue = parseInt(maxPrice / 10, 10) * 10 + 10;
			
			//PRICE SLIDER #1
			$("#slider-range1").slider({
				range: true,
				min: minSliderValue,
				max: maxSliderValue,
				values: [ minSliderValue, maxSliderValue ],
				step: 10,
				slide: function(event, ui) {
					$("#filterByPrice").val(ui.values[0] + " " + $.cookie('currency') + " - " + ui.values[1] + " " + $.cookie('currency'));
				}
			});
			
			$("#filterByPrice").val($("#slider-range1").slider("values", 0) + " " + $.cookie('currency') + " - " + $("#slider-range1").slider("values", 1) + " " + $.cookie('currency'));
			
			$("#slider-range1").slider({change: function(event, ui) {
				applyFilter();
				$('#resetFilterPrice').show();
			}});
		}
		
		if(SBus.sBusReturnResultTable != null){
			
			var minPrice = $(SBus.sBusReturnResultTable.first()).attr("data-minprice");
			var maxPrice = $(SBus.sBusReturnResultTable.last()).attr("data-minprice");
			var minSliderValue = parseInt(minPrice / 10, 10) * 10;
			var maxSliderValue = parseInt(maxPrice / 10, 10) * 10 + 10;
			
			//PRICE SLIDER #1
			$("#slider-range1").slider({
				range: true,
				min: minSliderValue,
				max: maxSliderValue,
				values: [ minSliderValue, maxSliderValue ],
				step: 10,
				slide: function(event, ui) {
					$("#filterByPrice").val(ui.values[0] + " " + $.cookie('currency') + " - " + ui.values[1] + " " + $.cookie('currency'));
				}
			});
			
			$("#filterByPrice").val($("#slider-range1").slider("values", 0) + " " + $.cookie('currency') + " - " + $("#slider-range1").slider("values", 1) + " " + $.cookie('currency'));
			
			$("#slider-range1").slider({change: function(event, ui) {
				applyFilter();
				$('#resetFilterPrice').show();
			}});
		}

	}

	this.applyDepartureFilter = function() {
		var filter = getFilter();
		SBus.sBusDepartureResultTable.each(function(index, item){
			var show = isMatchesFilter(item, filter);
			if(show)
				$( item ).show();
			else
				$( item ).hide();
		});
	}
	
	this.applyReturnFilter = function() {
		var filter = getFilter();
		SBus.sBusReturnResultTable.each(function(index, item){
			var show = isMatchesFilter(item, filter);
			if(show)
				$( item ).show();
			else
				$( item ).hide();
		});
	}

	
	function _fnEscapeRegex ( sVal ) {
		var letters = { "İ": "[İi]", "I": "[Iı]", "Ş": "[Şş]", "Ğ": "[Ğğ]", "Ü": "[Üü]", "Ö": "[Öö]", "Ç": "[Çç]", "i": "[İi]", "ı": "[Iı]", "ş": "[Şş]", "ğ": "[Ğğ]", "ü": "[Üü]", "ö": "[Öö]", "ç": "[Çç]" };
		return sVal.replace(/(([İIŞĞÜÇÖiışğüçö]))/g, function (letter) { return letters[letter]; });
	}

	var isMatchesFilter = function(item, filter){

		if(filter.minprice > $(item).attr("data-minprice") || filter.maxprice < $(item).attr("data-minprice"))
			return false;

		if($(item).attr("data-classname") in filter.classnames && !filter.classnames[$(item).attr("data-classname")]){
			return false;
		}
		
		if($(item).attr("data-returnclassname") in filter.returnclassnames && !filter.returnclassnames[$(item).attr("data-returnclassname")]){
			return false;
		}
		
		if($(item).attr("data-boattype") in filter.boattypes && !filter.boattypes[$(item).attr("data-boattype")]){
			return false;
		}
	
		return true;
	}
	
	this.resetFilter = function(filterName) {
		
	}
	
	var $classnames = $(".filter-classname");
	var $returnclassnames = $(".filter-returnclassname");
	var $boattypes = $(".filter-boattype");
	
	var getFilter = function(){
		
		var classnames = {}
		$classnames.each(function(index, item){
			classnames[item.value] = $(item).prop("checked");
		});
		
		var returnclassnames = {}
		$returnclassnames.each(function(index, item){
			returnclassnames[item.value] = $(item).prop("checked");
		});
		
		var boattypes = {}
		$boattypes.each(function(index, item){
			boattypes[item.value] = $(item).prop("checked");
		});
		
		return {
			minprice : $("#slider-range1").slider("values", 0),
			maxprice :  $("#slider-range1").slider("values", 1),
			classnames : classnames,
			returnclassnames : returnclassnames,
			boattypes : boattypes
		}
	}
	
	return {
		init : init,
		applyDepartureFilter : applyDepartureFilter,
		applyReturnFilter : applyReturnFilter,
		resetFilter : resetFilter
	}
	
}();

